var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper", class: { "popover-open": _vm.popoverOpen } },
    [
      _c(
        "el-popover",
        {
          ref: "notice-popover",
          attrs: {
            "popper-class": "notice-popover",
            placement: "bottom-end",
            offset: -3,
          },
          model: {
            value: _vm.popoverOpen,
            callback: function ($$v) {
              _vm.popoverOpen = $$v
            },
            expression: "popoverOpen",
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              on: { "tab-click": _vm.onTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _vm._l(_vm.tabOptions, function (tab) {
                return [
                  _c(
                    "el-tab-pane",
                    {
                      key: tab.title,
                      staticClass: "tab-pane",
                      attrs: { label: tab.titleShow, name: tab.title },
                    },
                    [
                      _c("notice-list", {
                        attrs: {
                          url: tab.url,
                          data: _vm.getNoticeData(tab.list),
                          title: "通知",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "popover",
              rawName: "v-popover:notice-popover",
              arg: "notice-popover",
            },
          ],
          staticClass: "noticeButton",
        },
        [
          _c(
            "el-badge",
            { staticClass: "badge", attrs: { value: _vm.unreadSize } },
            [_c("i", { staticClass: "fa fa-bell-o" })]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }